define.alias("shared/components/shared/plan-recommendation/steps/role", "settings/components/shared/plan-recommendation/steps/role");